import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'stepper-navigation',
  templateUrl: './stepper-navigation.component.html',
  styleUrls: ['./stepper-navigation.component.scss']
})
export class StepperNavigationComponent {
  // Ana sayfadan alınacak veriler
  @Input() buttonColor: string = '#64748b';    // outofoffice[this.flowIndex]?.color değeri paslanacak
  @Input() isNextDisabled: boolean = false;    // !nextBtn durumu paslanacak

  // Ana sayfadaki metodları tetikleyecek olay köprüleri
  @Output() back = new EventEmitter<void>();
  @Output() home = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();

  onBackClick() {
    this.back.emit();
  }

  onHomeClick() {
    this.home.emit();
  }

  onNextClick() {
    this.next.emit();
  }
}
